import { Alert } from "../alert/alert"; // @TODO: Move this file because a component cannot import another component
import qs from "qs";
import axios from "axios";
import { toggleDisplay } from "helpers/toggle/toggle";
import buttonLoader from "helpers/forms/button-loader/button-loader";

const AjaxPost = function (config) {
  this.formElement = config.formElement; //REQUIRED
  this.postData = config.postData; //REQUIRED
  this.validationObject = config.validationObject;
  this.messageContainer = config.messageContainer
    ? config.messageContainer
    : this.formElement;
  this.hideFormOnSuccess = config.hideFormOnSuccess
    ? config.hideFormOnSuccess
    : false;
  this.alert = new Alert({ container: this.messageContainer });
  this.onFormSuccess = config.onFormSuccess;
};

/*-----------------------------POST FORM DATA | do axios post call------------------------------*/
AjaxPost.prototype.postFormData = function () {
  //Check if there is postData and a form element.
  if (!this.postData || !this.formElement) {
    return;
  }

  //Do axios call
  axios
    .post(this.formElement.getAttribute("action"), qs.stringify(this.postData))
    .then(
      (response) => {
        //Check if there is a validation object for clientside validation.
        if (this.validationObject) {
          // make sure the server also validates successfully.
          this.validationObject.handleServerSideErrors(
            response.data,
            () => {
              // if server says ok, continue
              this.handleFormSuccess(response);
            },
            () => {
              this.handleFormMessages(response);
            },
          );
        } else if (response.data.success) {
          this.handleFormSuccess(response);
        } else if (response.data.messages.result) {
          this.handleFormMessages(response);
        }
      },
      (error) => {
        if (typeof Sentry !== "undefined") {
          Sentry.captureException(error);
        }
      },
    );
};

/*-----------------------------HANDLE FORM SUCCES | show success messages etc.------------------------------*/
AjaxPost.prototype.handleFormSuccess = function (response) {
  //Hide form on succes
  if (this.hideFormOnSuccess) {
    toggleDisplay({ isVisible: false, element: this.formElement });
  }

  //Show succes messages
  if (response.data.messages.result) {
    this.handleFormMessages(response);
  }

  if (typeof this.onFormSuccess === "function") {
    this.onFormSuccess(this);
  }

  // redirect to URL if available in response
  const redirectUrl = response.data.redirect;
  if (redirectUrl) {
    window.location.replace(redirectUrl);
  }
};

/*-----------------------------HANDLE FORM ERROR  | handle server side error message if they exist.------------------------------*/
AjaxPost.prototype.handleFormMessages = function (response) {
  const messages = response.data.messages.result;

  //Remove old messages
  this.messageContainer.querySelectorAll(".alert").forEach((alert) => {
    alert.remove();
  });

  //Set new messages
  if (messages && Array.isArray(messages)) {
    const variant = response.data.success ? "success" : "error";

    //If there are multiple messages, show messages in a list.
    // reset messageCollection
    let messagesCollection = "";
    // loop through errors object
    messages.forEach((msg) => {
      // add new element to message collection
      messagesCollection += `<span class="list-item">${msg}</span>`;
    });

    // Create new alert
    this.alert.setMessage(messagesCollection);
    this.alert.setVariant(variant);
    this.alert.show();
  }

  if (
    this.formElement.dataset.onSubmit &&
    this.formElement.dataset.onSubmit === "button-loader"
  ) {
    buttonLoader.removeSubmitButtonLoader(
      this.formElement.querySelector(".btn"),
    );
  }
};

export default AjaxPost;
